import { optional, string, z } from '@kaiizen/zod-less';

export const ApiProductSupplierSchema = z.object({
  id: string,
  name: string,
  address: optional(string),
  archivedAt: optional(string),
  createdAt: string,
  updatedAt: string,
});

export const ApiCreateProductSupplierSchema = z.object({
  name: string,
  address: optional(string),
});

export const ApiUpdateProductSupplierSchema = z.object({
  name: optional(string),
  address: optional(string),
  archivedAt: optional(string),
});

export type ApiProductSupplier = z.infer<typeof ApiProductSupplierSchema>;
export type ApiCreateProductSupplier = z.infer<typeof ApiCreateProductSupplierSchema>;
export type ApiUpdateProductSupplier = z.infer<typeof ApiUpdateProductSupplierSchema>;
